import React, { useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import ScrollToTop from "../ScrollToTop";
import AnimatedCursor from "react-animated-cursor";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";

export default function Layout({ children }) {
  useEffect(() => {
    AOS.init();
  }, []);

  const { sanitySitesettings } = useStaticQuery(
    graphql`
      query {
        sanitySitesettings {
          header {
            logo {
              height
              width
              alt
              image {
                asset {
                  gatsbyImageData(
                    fit: FILLMAX
                    placeholder: BLURRED
                    formats: WEBP
                  )
                }
              }
            }
            menu {
              label {
                text
                color {
                  hex
                }
              }
              hover {
                hex
              }
              path
              svg
            }
          }

          cursor {
            enable
            color {
              rgb {
                r
                g
                b
              }
            }
          }
          scroll {
            hex
          }

          _rawCc
        }
      }
    `
  );

  const rgb = sanitySitesettings?.cursor?.color?.rgb;
  return (
    <div className="civsav_tm_all_wrap" id="root">
      {sanitySitesettings?.cursor && sanitySitesettings.cursor?.enable && (
        <AnimatedCursor
          innerSize={8}
          outerSize={44}
          color={`${rgb?.r}, ${rgb?.g}, ${rgb?.b}`}
          outerAlpha={0.3}
          innerScale={0.7}
          outerScale={1.2}
        />
      )}
      <ScrollToTop color={sanitySitesettings?.scroll} />
      <Header data={sanitySitesettings} />
      <main>{children}</main>
      <div className="civsav_tm_copyright">
        <div className="container">
          <Footer data={sanitySitesettings?._rawCc} />
        </div>
      </div>
    </div>
  );
}
